import React, { useContext, useState, useMemo, useEffect } from 'react';
import {
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from 'reactstrap';
import BreadCrumb from '../Components/Common/BreadCrumb';
import TableContainer from '../Components/Common/TableContainer';
import DeleteModal from '../Components/Common/DeleteModal';
import { ContactMessageContext } from '../context/ContactMessageContext';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import 'moment/locale/fa';
import { Link } from 'react-router-dom';

const ContactMessages = () => {
  document.title = 'پیام‌های تماس | فات 90';

  const { messages, loading, error, fetchMessages, removeMessage } = useContext(ContactMessageContext);
  const [message, setMessage] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  // دریافت پیام‌ها در بارگذاری اولیه
  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  // حذف تکی
  const onClickDelete = (msg) => {
    setMessage(msg);
    setDeleteModal(true);
  };

  const handleDeleteMessage = async () => {
    if (message) {
      try {
        await removeMessage(message.id);
        setDeleteModal(false);
      } catch (err) {
        // خطاها توسط ContactMessageContext مدیریت می‌شن
      }
    }
  };

  // انتخاب چندگانه
  const checkedAll = () => {
    const checkall = document.getElementById('checkBoxAll');
    const ele = document.querySelectorAll('.messageCheckBox');
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll('.messageCheckBox:checked');
    setIsMultiDeleteButton(ele.length > 0);
    setSelectedCheckBoxDelete(ele);
  };

  const deleteMultiple = async () => {
    const checkall = document.getElementById('checkBoxAll');
    try {
      for (const element of selectedCheckBoxDelete) {
        await removeMessage(parseInt(element.value));
      }
      setIsMultiDeleteButton(false);
      checkall.checked = false;
      setDeleteModalMulti(false);
    } catch (err) {
      // خطاها توسط ContactMessageContext مدیریت می‌شن
    }
  };

  // ستون‌های جدول
  const columns = useMemo(
    () => [
      {
        header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            className="form-check-input"
            onClick={() => checkedAll()}
          />
        ),
        cell: (cell) => (
          <input
            type="checkbox"
            className="messageCheckBox form-check-input"
            value={cell.getValue()}
            onChange={() => deleteCheckbox()}
          />
        ),
        id: '#',
        accessorKey: 'id',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'نام و نام خانوادگی',
        accessorKey: 'fullName',
        enableColumnFilter: false,
      },
      {
        header: 'ایمیل',
        accessorKey: 'email',
        enableColumnFilter: false,
      },
      {
        header: 'موضوع',
        accessorKey: 'subject',
        enableColumnFilter: false,
      },
      {
        header: 'پیام',
        accessorKey: 'message',
        enableColumnFilter: false,
        cell: (cell) => (
          <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {cell.getValue()}
          </div>
        ),
      },
      {
        header: 'تاریخ ارسال',
        accessorKey: 'sentAt',
        enableColumnFilter: false,
        cell: (cell) => moment(cell.getValue()).locale('fa').format('DD MMM YYYY, HH:mm'),
      },
      {
        header: 'عملیات',
        cell: (cell) => (
          <UncontrolledDropdown>
            <DropdownToggle href="#" className="btn btn-soft-secondary btn-sm" tag="button">
              <i className="ri-more-fill" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                href="#"
                onClick={() => {
                  const msgData = cell.row.original;
                  onClickDelete(msgData);
                }}
              >
                <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i> حذف
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        ),
      },
    ],
    []
  );

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteMessage}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={deleteMultiple}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="پیام‌های تماس" pageTitle="مدیریت" />
        <Row>
          <Col xl={12}>
            <Card>
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col>
                    <h5 className="card-title mb-0">لیست پیام‌های تماس</h5>
                  </Col>
                  <Col className="text-end">
                    {isMultiDeleteButton && (
                      <button
                        className="btn btn-soft-danger"
                        onClick={() => setDeleteModalMulti(true)}
                      >
                        <i className="ri-delete-bin-2-line"></i> حذف انتخاب‌شده‌ها
                      </button>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="pt-0">
                {loading ? (
                  <div className="py-4 text-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/msoeawqm.json"
                      trigger="loop"
                      colors="primary:#25a0e2,secondary:#00bd9d"
                      style={{ width: '72px', height: '72px' }}
                    ></lord-icon>
                    <h5 className="mt-4">در حال بارگذاری...</h5>
                  </div>
                ) : error ? (
                  <div className="py-4 text-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/msoeawqm.json"
                      trigger="loop"
                      colors="primary:#25a0e2,secondary:#00bd9d"
                      style={{ width: '72px', height: '72px' }}
                    ></lord-icon>
                    <h5 className="mt-4">{error}</h5>
                  </div>
                ) : messages && messages.length > 0 ? (
                  <TableContainer
                    columns={columns}
                    data={messages}
                    isGlobalFilter={true}
                    isAddUserList={false}
                    customPageSize={10}
                    divClass="table-responsive mb-1"
                    tableClass="mb-0 align-middle table-borderless"
                    theadClass="table-light text-muted"
                    SearchPlaceholder="جستجو بر اساس نام، ایمیل یا موضوع..."
                  />
                ) : (
                  <div className="py-4 text-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/msoeawqm.json"
                      trigger="loop"
                      colors="primary:#25a0e2,secondary:#00bd9d"
                      style={{ width: '72px', height: '72px' }}
                    ></lord-icon>
                    <h5 className="mt-4">هیچ پیامی یافت نشد</h5>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactMessages;